const SET_SIDEBAR_ACTIVE_TAB = "SET_SIDEBAR_ACTIVE_TAB";

export default SET_SIDEBAR_ACTIVE_TAB;
